import React, { Component } from 'react';
import { EUIPage } from '../EUI/EUIPage';

export class SignatureEiffage extends Component {

    render = () => <EUIPage
        baseUrl="/SignaturesEiffage"
        onglets={[
            { url: "/ContratsDeReservations", titre: "Contrats de réservations" },
        ]}
    />;

}